import './App.css';
import GsapLptopScreen from './components/GSAP/GsapLptopScreen';
import Header from './components/HEADER/Header';

function App() {
  return (
    <div className='w-dvw h-fit overflow-x-hidden relative'>
      <GsapLptopScreen />
    </div>
  );
}

export default App;
